module.exports = {"321324100":"青阳镇","321324101":"双沟镇","321324102":"上塘镇","321324103":"魏营镇","321324104":"临淮镇","321324105":"半城镇","321324106":"孙园镇","321324107":"梅花镇","321324108":"归仁镇","321324109":"金锁镇","321324110":"朱湖镇","321324111":"界集镇","321324112":"太平镇","321324113":"龙集镇","321324200":"四河乡","321324201":"峰山乡","321324202":"天岗湖乡","321324203":"车门乡","321324204":"瑶沟乡","321324205":"石集乡","321324206":"城头乡","321324207":"陈圩乡","321324208":"曹庙乡","321324400":"五里江农场","321324401":"洪泽湖农场","321324402":"泗洪经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321324.json
// module id = 864
// module chunks = 0